export const draftModalActionButton = (theme) => ({
  padding: theme.spacing(0, 4),
  color: theme.colorPalette.white,
  fontSize: 16,
  fontWeight: 600,
  lineHeight: 1.5
});

/** The "Please select an option" card shared by the preview's next-step choice and the underwriter's review. */
export const decisionCardStyles = (theme) => ({
  decisionCard: {
    padding: theme.spacing(4),
    backgroundColor: theme.colorPalette.beige_40,
    boxShadow: 'none'
  },
  decisionCardTitle: {
    color: theme.colorPalette.green_80,
    fontSize: 20,
    fontWeight: 400,
    marginBottom: theme.spacing(2)
  },
  decisionCardPrompt: {
    marginBottom: theme.spacing(2),
    color: theme.colorPalette.green_80,
    fontSize: 16,
    fontWeight: 600
  },
  decisionCardRadioGroup: {
    display: 'flex',
    flexDirection: 'column',
    '& .MuiFormControlLabel-label': {
      color: theme.colorPalette.green_80
    },
    // top-level `disabled` keys in material-overrides compile to the bare global `.Mui-disabled`
    // selector, so MuiInput's 40% opacity reaches the radio and label spans here; hold every
    // disabled element opaque so the lock icon stays full strength, and fade via color instead
    '& .Mui-disabled': {
      opacity: 1
    },
    '& .MuiFormControlLabel-label.Mui-disabled': {
      color: theme.colorPalette.green_80_op_60
    },
    '& .MuiRadio-root.Mui-disabled': {
      color: theme.colorPalette.green_80_op_60
    }
  },
  decisionCardActions: {
    display: 'flex',
    justifyContent: 'flex-end',
    gap: theme.spacing(2),
    marginTop: theme.spacing(3)
  },
  decisionCardCancelButton: {
    width: 85,
    backgroundColor: theme.colorPalette.orange_50,
    color: theme.colorPalette.white,
    '&:hover': {
      backgroundColor: theme.colorPalette.orange_75
    }
  },
  decisionCardSubmitButton: {
    backgroundColor: theme.colorPalette.green_90,
    color: theme.colorPalette.white,
    '&:hover': {
      backgroundColor: theme.colorPalette.green_100
    }
  }
});
